import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { formatDateStringWithTimezone, formatCurrency } from '../../../utils/formatters';
import ViewButton from '../../elements/ViewButton';
import Paginator from '../../elements/paginator';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';
import { EMPTY_CELL } from 'crm/elements/common/TableDetailsRow';
import TableHead from 'crm/elements/common/TableHead';
import { PERMISSION } from 'crm/helpers/Permissions';

function PromoCodeTickets() {
    const { id } = useParams();
    const [tickets, setTickets] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const url = `/crea/api/promocode/${id}/tickets`;

    const getTickets = (page = 1) => {
        axios.get(`${url}?page=${page}`).then((response) => {
            setTickets(response.data.data);
            setCurrentPage(response.data.meta.current_page);
            setLastPage(response.data.meta.last_page);
        });
    };

    useEffect(() => {
        getTickets();
    }, []);

    function getTicketsList() {
        return tickets.map((ticket) => (
            <tr key={id}>
                <td>
                    <ViewButton
                        url={`/tickets/${ticket.id}`}
                        permissions={[PERMISSION.VIEW_TICKET]}
                        title="View ticket"
                    />
                    <ViewButton
                        url={`/users/${ticket.user_id}`}
                        permissions={[PERMISSION.VIEW_USER]}
                        title="View user"
                    />
                </td>
                <td>{ticket.email}</td>
                <td>{ticket.promo_code_used}</td>
                <td>{ticket.token}</td>
                <td>{formatDateStringWithTimezone(ticket.created_at)}</td>
                <td>{getDiscount(ticket.discount_type, ticket.discount_amount)}</td>
            </tr>
        ));
    }

    function getDiscount(bonus, amount) {
        switch (bonus) {
            case 'ticket':
                return '100%';
            case 'amount_discount':
                return formatCurrency(amount);
            case 'percentage_discount':
                return `${amount}%`;
            default:
                return EMPTY_CELL;
        }
    }

    return (
        <Card title="Tickets">
            <div className="table-responsive">
                <table className="table model-list">
                    <TableHead>
                        <div />
                        <th>E-mail</th>
                        <th>Promo Code</th>
                        <th>Token</th>
                        <th>Date</th>
                        <th>Discount</th>
                    </TableHead>
                    <tbody>{getTicketsList()}</tbody>
                </table>
                <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getTickets} />
            </div>
        </Card>
    );
}

export default PromoCodeTickets;
